module.exports = __webpack_public_path__ + "media/delete.74682ff1.ogg";